import { useTranslation } from 'react-i18next';
import type { Role } from '../api/client';

/**
 * El rol de una persona, en el listado.
 *
 * Existe por una pregunta concreta que no se podía contestar: **a quién le va a
 * pedir el portal un código al entrar**. El segundo factor se le exige a quien
 * administra y a nadie más, pero eso sólo se veía abriendo cuenta por cuenta, y
 * con 261 personas eso no se hace. Así que la píldora no dice sólo el rol: marca
 * los que administran, que son los que llevan segundo factor.
 *
 * No depende del color: el nombre del rol ya distingue, y el título al pasar el
 * cursor lo dice con todas sus letras.
 */
export function PildoraRol({ codigos, roles }: { codigos: string[]; roles: Role[] }) {
  const { t } = useTranslation();

  if (codigos.length === 0) {
    return (
      <span className="pildora-rol pildora-rol--ninguno" title={t('users.roleNoneHelp')}>
        {t('users.roleNone')}
      </span>
    );
  }

  return (
    <span className="pildora-rol-grupo">
      {codigos.map((codigo) => {
        const rol = roles.find((r) => r.code === codigo);
        const nombre = rol?.name ?? codigo;
        const administra = rol?.isPrivileged ?? false;
        return (
          <span
            key={codigo}
            className={`pildora-rol${administra ? ' pildora-rol--administra' : ''}`}
            title={administra ? t('users.roleAsksOtp') : t('users.roleNoOtp')}
          >
            {nombre}
          </span>
        );
      })}
    </span>
  );
}
